












import {defineComponent} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import HeaderImage from "@/apps/MyStudyChoiceOnboardingWidget/components/steps/atoms/HeaderImage.vue"

export default defineComponent({
    name: "WelcomeStep",
    components: {HeaderImage},
    setup: () => {
        const {setCanContinue} = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setCanContinue'
        ])
        const {getLabels} = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getLabels'
        ])
        setCanContinue(true)
        return {
            getLabels
        }
    }
})
